<template>
  <el-dialog
    :model-value="visible"
    title="标签管理"
    width="520px"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:visible', $event)"
    @open="fetchList"
  >
    <div class="mb-3 flex gap-2">
      <el-input v-model="newTagName" placeholder="新标签名称" maxlength="64" class="flex-1" @keyup.enter="handleCreate" />
      <el-color-picker v-model="newTagColor" />
      <el-button type="primary" :disabled="!newTagName" @click="handleCreate">添加</el-button>
    </div>
    <div class="max-h-80 overflow-y-auto" v-loading="loading">
      <div
        v-for="tag in list"
        :key="tag.id"
        class="flex items-center gap-3 py-2.5 px-2 border-b border-slate-50 last:border-0"
      >
        <span class="w-3 h-3 rounded-full shrink-0" :style="{ backgroundColor: tag.color || '#94a3b8' }"></span>
        <input
          v-if="editingId === tag.id"
          v-model="editingName"
          class="flex-1 text-sm px-2 py-1 border border-primary-300 rounded outline-none focus:border-primary-500"
          @keyup.enter="handleUpdate(tag)"
          @keyup.escape="editingId = null"
        />
        <span v-else class="flex-1 text-sm text-slate-700">{{ tag.name }}</span>
        <div class="flex items-center gap-1 shrink-0">
          <el-button text size="small" @click="startEdit(tag)">
            <el-icon :size="14"><Edit /></el-icon>
          </el-button>
          <el-button text size="small" type="danger" @click="handleDelete(tag)">
            <el-icon :size="14"><Delete /></el-icon>
          </el-button>
        </div>
      </div>
    </div>
    <template #footer>
      <el-button @click="$emit('update:visible', false)">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Edit, Delete } from '@element-plus/icons-vue'
import { getTagList, createTag, updateTag, deleteTag } from '@/api/assets'

defineProps({
  visible: { type: Boolean, default: false }
})

const emit = defineEmits(['update:visible', 'refresh'])

const list = ref([])
const loading = ref(false)
const newTagName = ref('')
const newTagColor = ref('#3B82F6')
const editingId = ref(null)
const editingName = ref('')

async function fetchList() {
  loading.value = true
  try {
    const data = await getTagList()
    list.value = data || []
  } catch {
    // handled by interceptor
  } finally {
    loading.value = false
  }
}

async function handleCreate() {
  if (!newTagName.value) return
  try {
    await createTag({ name: newTagName.value, color: newTagColor.value, sort: list.value.length })
    ElMessage.success('标签已创建')
    newTagName.value = ''
    await fetchList()
    emit('refresh')
  } catch {
    // handled by interceptor
  }
}

function startEdit(tag) {
  editingId.value = tag.id
  editingName.value = tag.name
}

async function handleUpdate(tag) {
  if (!editingName.value) return
  try {
    await updateTag(tag.id, { name: editingName.value, color: tag.color, sort: tag.sort, status: tag.status })
    editingId.value = null
    ElMessage.success('标签已更新')
    await fetchList()
    emit('refresh')
  } catch {
    // handled by interceptor
  }
}

async function handleDelete(tag) {
  try {
    await ElMessageBox.confirm(
      `确定删除标签「${tag.name}」吗？被素材使用的标签无法删除。`,
      '删除确认',
      { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }
    )
    await deleteTag(tag.id)
    ElMessage.success('标签已删除')
    await fetchList()
    emit('refresh')
  } catch {
    // 取消或错误
  }
}
</script>
